import React from 'react';
import {SDrawerOrModal,} from 'shj-components'
import {Button, message} from 'antd';
import {useNavigate} from "react-router-dom";
import {generateIframeSrc} from "@/services/kuAccount.ts";

export default function DesignMasterModal({
                                            editId = '',
                                            open = false,
                                            basicInfo = {},
                                            onClose = () => {
                                            },
                                            reload = () => {
                                            },
                                          }) {
  const navigate = useNavigate()

  const accountFn = () => {
    onClose()
    navigate('/saleOp/basicConfig/kuklerAccount')
  }

  // 去做酷家乐方案--new
  const gokjl = async () => {
    try {
      message.loading({
        content: '查询中..',
        duration: 0,
      })
      generateIframeSrc({bizOpId: editId, dest: 1}).then(url => {
        if (!url.startsWith('http')) {
          onClose()
          message.destroy()
          message.info('未领取酷家乐账号，请前往酷家乐账号列表领取')
        } else {
          window.open(url)
          message.destroy()
        }
      })

    } catch {
      message.destroy()
    }
  }

  const onBindCase = () => {
    onClose();
    navigate('/saleOp/basicConfig/kjlManager/' + editId)
  }

  const onBindCaseCopy = () => {
    onClose();
    navigate('/saleOp/basicConfig/kjlManagerCopy/' + editId)
  }

  return (
      <div>
        <SDrawerOrModal
            mode="modal"
            open={open}
            width={600}
            onCancel={() => onClose()}
            antdProps={{
              footer: []
            }}
            title="去设计大师"
        >
          <div style={{marginTop: 15}}>
            <Button type={'primary'} style={{marginRight: 15}} onClick={accountFn}>账号管理</Button>
            <Button type={'primary'} style={{marginRight: 15}} onClick={() => gokjl()}>去做方案</Button>
            <Button type={'primary'} style={{marginRight: 15}} onClick={() => onBindCase()}>绑定已有方案</Button>
            <Button type={'primary'} onClick={() => onBindCaseCopy()}>复制绑定已有方案</Button>
          </div>

        </SDrawerOrModal>
      </div>
  )
}